import React from "react";
import { Route, Routes } from "react-router-dom";
import PaymentList from "../../component/Payment/List";

function PaymentPage() {
  return (
    <Routes>
      <Route path="/*" element={<PaymentList />} />
    </Routes>
  );
}

export default PaymentPage;
